/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
const money_left = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeWidth={1.5}
      d="M1 8a7 7 0 1 0 7-7M5.79 8.8h4.455c.176 0 .319.14.319.31v1.379a.315.315 0 0 1-.319.31H5.792a.315.315 0 0 1-.318-.31V9.11c0-.172.142-.311.318-.311Zm.637-2h4.455c.175 0 .318.14.318.31v1.38a.315.315 0 0 1-.318.31H6.427a.315.315 0 0 1-.318-.31V7.11c0-.172.143-.311.318-.311Zm-1.909-2h4.455c.175 0 .318.14.318.31v1.38a.315.315 0 0 1-.318.31H4.518a.315.315 0 0 1-.318-.31V5.11c0-.172.142-.311.318-.311Z"
    />
  </svg>
)
export default money_left
